import { render, staticRenderFns } from "./ReqSpec.vue?vue&type=template&id=a8e41694&scoped=true&"
import script from "./ReqSpec.vue?vue&type=script&lang=js&"
export * from "./ReqSpec.vue?vue&type=script&lang=js&"
import style0 from "./ReqSpec.vue?vue&type=style&index=0&id=a8e41694&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8e41694",
  null
  
)

export default component.exports